import React, { useCallback, useRef } from 'react'

import { Box } from 'widgets/Box'

import { InProgressPost, InProgressPostStep } from 'types/post'

import { AddStepsButton } from './AddStepsButton'

import { BaseMultipleStepForm } from '../BaseMultipleStepForm'

type Values = InProgressPost['steps'][number]

interface StepFormProps {
  addStep: (insertAtIndex: number) => void
  initialValues?: Values
  onValuesChange: (values: Values) => void
  stepIndex?: number
  deleteStepAtIndex: (stepIndex: number, navigate?: boolean) => void
  saveMultipleSteps: (stepsData: Partial<InProgressPostStep[]>) => void
}

export const WorkoutStepsForm = ({
  addStep,
  initialValues,
  onValuesChange,
  stepIndex,
  deleteStepAtIndex,
  saveMultipleSteps,
}: StepFormProps) => {
  const openImagePickerRef = useRef<any>(null)

  const getChildren = useCallback(
    (mediaSelector: JSX.Element) => (
      <Box align='center' justifyContent='center'>
        <Box>{mediaSelector}</Box>
      </Box>
    ),
    [addStep, deleteStepAtIndex, stepIndex],
  )

  return (
    <>
      <BaseMultipleStepForm
        ref={openImagePickerRef}
        allowedFileType='both'
        initialValues={{
          ...initialValues,
        }}
        onValuesChange={onValuesChange}
        saveMultipleSteps={saveMultipleSteps}
        deleteStepAtIndex={deleteStepAtIndex}
        insertStepAtIndex={addStep}
      >
        {getChildren}
      </BaseMultipleStepForm>
      {!initialValues?.steps?.length && (
        <AddStepsButton onPress={() => openImagePickerRef?.current?.openFileUpload()} />
      )}
    </>
  )
}
